export const UPDATE_SELECTED_LOCATIONS = "UPDATE_SELECTED_LOCATIONS";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_IS_DUPLICATE = "SET_IS_DUPLICATE";
export const SET_IS_ERROR = "SET_IS_ERROR";
export const SET_WEATHER_DATA = "SET_WEATHER_DATA";
export const UPDATE_WEATHER_DATA = "UPDATE_WEATHER_DATA";
export const DELETE_WEATHER_DATA = "DELETE_WEATHER_DATA";